import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

import { SASEUNG3_STATS_API_URL } from '../../defines/protocol';
import { ApiService } from '../api/api.service';

export interface Saseung3StatsResponse {
  character_total_count: number;
  tone_marked_character_count: number;
}

export const SASEUNG3_STATS_FALLBACK_CHARACTER_TOTAL_COUNT = 16435;
export const SASEUNG3_STATS_FALLBACK_TONE_MARKED_CHARACTER_COUNT = 3990;

@Injectable({
  providedIn: 'root',
})
export class Saseung3StatsService {
  private stats$: Observable<Saseung3StatsResponse> = null;

  constructor(
    private api: ApiService,
  ) {
  }

  public getStats(): Observable<Saseung3StatsResponse> {
    if (!this.stats$) {
      this.stats$ = this.api.Get(SASEUNG3_STATS_API_URL).pipe(
        map((response: Partial<Saseung3StatsResponse> | null | undefined) => ({
          character_total_count: this.toSafeNumber(
            response?.character_total_count,
            SASEUNG3_STATS_FALLBACK_CHARACTER_TOTAL_COUNT,
          ),
          tone_marked_character_count: this.toSafeNumber(
            response?.tone_marked_character_count,
            SASEUNG3_STATS_FALLBACK_TONE_MARKED_CHARACTER_COUNT,
          ),
        })),
        catchError((error) => {
          console.error('Saseung3StatsService::getStats() failed', {
            url: SASEUNG3_STATS_API_URL,
            status: error?.status,
            message: error?.message,
          });
          this.stats$ = null;
          return of(this.getFallbackStats());
        }),
        shareReplay(1),
      );
    }

    return this.stats$;
  }

  private toSafeNumber(value: number | null | undefined, fallback: number): number {
    return value == null ? fallback : value;
  }

  private getFallbackStats(): Saseung3StatsResponse {
    return {
      character_total_count: SASEUNG3_STATS_FALLBACK_CHARACTER_TOTAL_COUNT,
      tone_marked_character_count: SASEUNG3_STATS_FALLBACK_TONE_MARKED_CHARACTER_COUNT,
    };
  }
}
